import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShiftI18n } from '../../i18n/ShiftI18nContext';

/** 舊連結：導回主頁並開啟回報分頁，保留導覽 */
export default function ShiftAnomalyPage() {
  const nav = useNavigate();
  const { t } = useShiftI18n();
  useEffect(() => {
    nav('/shift/home?tab=anomalies', { replace: true });
  }, [nav]);
  return <div className="shift-empty">{t('anomaly.redirect')}</div>;
}
